import type { ChartSeriesBuilderMisc, ChartSeriesDef } from "./types";

export interface SeriesMiscSources {
  /** The builder misc the data query reads its date fields from. */
  date: ChartSeriesBuilderMisc | undefined;
  /** The builder misc the data query reads its subject fields from. */
  subject: ChartSeriesBuilderMisc | undefined;
}

/**
 * An ACWR companion stores only its metric and its parent id, so it reads its
 * parent's misc.
 */
function ownMisc(
  series: ChartSeriesDef | undefined,
  allSeries: ChartSeriesDef[],
): ChartSeriesBuilderMisc | undefined {
  const misc = series?.series_builder_misc;
  if (misc?.isAcwrCompanion !== true) return misc;
  const parent = allSeries.find((s) => s.queryId === misc.parentQueryId);
  return parent?.series_builder_misc ?? misc;
}

function hasOwnDateRange(misc: ChartSeriesBuilderMisc | undefined): boolean {
  return (
    misc?.inheritDateRange === false &&
    !!(misc.dateRangePreset || misc.showAdvancedDate || (misc.dayFilter?.length ?? 0) > 0)
  );
}

function hasOwnSubjects(misc: ChartSeriesBuilderMisc | undefined): boolean {
  return misc?.inheritPlayers === false && misc.selectedSubjects != null;
}

/**
 * The builder misc a chart series reads its date and subject fields from.
 * A series follows the first series unless its own inherit flag is false.
 * buildQueries, the legend, the info popover and the custom reference lines
 * all resolve through here, so they agree.
 */
export function resolveSeriesMisc(
  series: ChartSeriesDef | undefined,
  allSeries: ChartSeriesDef[],
): SeriesMiscSources {
  const misc = ownMisc(series, allSeries);
  const firstMisc = ownMisc(allSeries[0], allSeries);
  return {
    date: hasOwnDateRange(misc) ? misc : firstMisc,
    subject: hasOwnSubjects(misc) ? misc : firstMisc,
  };
}
